var React = require('react');

function CTAArrow (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#0BB4DC;}\n"),React.createElement("polygon",{"className":"st0","points":"0.7,8.1 0,7.4 3.4,4.1 0,0.7 0.7,0 4.8,4.1 ","key":1})]);
}

CTAArrow.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 4.8 8.1","style":{"enableBackground":"new 0 0 4.8 8.1"},"xmlSpace":"preserve"};

module.exports = CTAArrow;

CTAArrow.default = CTAArrow;
